/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-10-10 10:33:30
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Heading } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { FieldArray } from 'redux-form';

import RuleGroupListContainer from 'src/components/containers/recommendation/widget/item/general/rule-group-list-container';

type Props = WithI18nProps & { formValues: Object, updateField: Function };

class HandPickedProducts extends Component<Props> {
  render() {
    const { i18n, pageType = '' } = this.props;

    return (
      <div className="general-items">
        <Heading>
          {i18n.translate(
            `AdminHTML.Recommendation.WidgetItem.recommendationSettings_RuleGroups${
              pageType === 'product-page' ? '_ProductPage' : ''
            }_Label`
          )}
        </Heading>

        <FieldArray name="ruleGroup" component={RuleGroupListContainer} />
      </div>
    );
  }
}

export default withI18n()(HandPickedProducts);
